import { render, staticRenderFns } from "./teleInfoList.vue?vue&type=template&id=d23031fc&"
import script from "./teleInfoList.vue?vue&type=script&lang=js&"
export * from "./teleInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports